var _defs, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKnot(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#7b58a5;stroke-miterlimit:10;stroke-width:4.1px;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "knot") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.88,73.1C156.1,25.19,208.41,6,264.81,6,320,6,377.43,26.17,396.38,65c9,5.87,15.83,13.38,13.26,24.32a14.78,14.78,0,0,1-.79,11c1,2.87,1.41,14.36-10.57,21.63-21.69,55-72.55,95.54-109.93,131.26C318.4,279,373,331.76,388.43,367.87c14.48,3.18,24.51,16.25,19.52,23.83,1.62,5.5,1.86,9.29.09,12,.55,2.84,1.22,7.46-1.22,10.51,2.26,5.75.18,13.81-10.45,19.13C380.24,487.15,308.63,506,260.88,506c-84,0-148.71-33.43-151.46-87.23-8.44-9.78-8.74-19.4-6.72-26.19A110.42,110.42,0,0,1,108.44,377c1.47-3.06,6.72-12,16.86-14.18,27.13-42.9,75.53-86.65,103.82-113-38.38-36.42-85.79-82.86-97-122.64-7.21-5.44-11.32-11.79-11.55-15.52-.49-7.81-1.16-19.31-1-21.6C119.81,86.84,122.53,77.68,132.88,73.1Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M171.75,78c9.53-36.24,62.57-55.91,102.66-56.77,35.93-.77,73.21,18.82,83.47,46.68-5.13,4-12.47,13.69-11.12,24.08a40.44,40.44,0,0,0-.49,10c-1.59,3.54-1.34,14.54,2.44,18.94-14.36,31.84-70.49,83.77-91.54,103.41-51.32-47.56-72.71-75.92-84-104.58a23,23,0,0,0,5.59-13c.46-4.12-.18-16.77-.18-18.7S174.59,80.06,171.75,78Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.88,278.6c17.31,13.38,75.36,70.21,90.33,106.51-1.65,3.3-.55,8-.49,9.47a17.1,17.1,0,0,0-.55,9.84c-.92,2.26-3.91,15.7,7.21,23.4-10,46-65.2,63.61-114.39,63.61s-92.15-33.36-90.5-66c8.07-5.87,10.14-10.41,12.19-15.49,4.86-12,7-19.07,1.74-27.59C181.4,356.39,215.62,319.6,260.88,278.6Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M119.61,92.89c0,4.76,6.07,21,28.19,21,24.44,0,30.74-19.43,30.74-25.79"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M120.21,101c0,12.28,13.66,21.2,27.1,21.2,13.08,0,31.23-8.31,31.23-26.52"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.15,127.17c13.57,8,35.32.92,41-7.33"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M132.88,73.1c-1.83,5.13-4.4,16.74-4.65,20.16,4,3.91,8.94,9.64,19.68,9,11-.61,19.68-8.31,21.51-14.6,1.22-4.83,1.55-7.58,2.32-9.66"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M139.24,101c.37-13.26,3.26-25.2,11.85-36.73,15.4-20.65,51.33-45.59,108.77-45.59,14.66,0,39.6,1.35,63.07,13.68"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M297.07,22.77c-22.76-4.58-34.45-3.53-62,1.1-40.33,6.78-85.09,36-80.47,77.15"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.39,102.35c-1.1-9-1-35.65,26.32-56.4"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M157.66,99.8c-1.43-10,1.69-35.22,16.44-46.73"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M357.88,68c5.85-5,23.86-9.62,38.5-2.93"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256,6C294.21,6,349,15.66,369.79,62.82"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M274.65,6.21c44.12,1.5,92.27,22.64,107.43,55.47"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.76,92c1.71-7,10.57-19.62,31.9-20.29,12.46-.39,25.3,4.64,31,17.6"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M346.27,102.06c1.77-4.83,9-19.14,32.45-19.74,17.17-.44,27.86,10,30.13,18"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M348.71,121c1.83-4.15,7.58-16.5,8.31-18.94s10.39-7.33,21.17-7.33c12.19,0,28,7.94,20.07,27.25"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M371.82,95.28c-14.43,95.88-224.76,209.59-248.29,304.8"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M127.26,402.58C148.28,305.3,365.82,185,375,94.87"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M387.5,96.24C371.82,201.18,157.75,312.44,139.18,406.3"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143,405.91C170.28,303.53,384.4,189.32,390.63,97.53"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M125.31,362.86c-3.3,6.11-19.66,32.06,6.72,42,15.83,6,27.19-8.43,34.4-22.55"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M229.13,249.82c3.21-3.21,26-23.46,28-25.4"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M145.35,130.68C161,172.45,224.21,229.86,237.78,242"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.26,130.68c15.95,41.83,76.08,97.62,89.55,110.25"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M160.85,128c15.48,40.92,77.28,97.2,86.33,105.35"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M163.64,126.9c12.14,32.08,51.81,75.72,84.81,105.35"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M351.22,385.11c1.53-4,11.31-20.9,37.22-17.23"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M260.88,278.6c2.71-2.47,25.23-23.24,27.46-25.36"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M269.26,270.88c29.71,26.72,79.57,77.92,89.38,104.33"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M270.38,269.85c7.57,7.09,76.74,68.93,91.27,103.08"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M372.22,368.38c-14.83-32.28-72.64-88.5-93.76-106"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M375.23,367.76c-9.53-23.9-49.89-66.25-95.39-106.65"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.73,394.58c3.24-7.52,10.61-17.7,28.78-17.78,13.44-.06,21.94,4.89,28.45,14.91"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M350.18,404.42c2.93-7,10.94-18,29.16-18,14.71,0,25.22,7.94,28.7,17.29"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M109.42,418.75c10.91,10.27,24.91,14.92,43.08,6.69"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M259.93,506c-25.48.61-113.6-9.9-119.55-76.78"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M159.66,471.26C149.75,461,140.38,446.15,138,429.5"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M256.9,506c-23.8,0-121.08-9.19-131.51-77.67"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M143.32,465.61c-6.71-6.87-18.56-23.79-20.26-38.06"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M394.72,438.21c1.29-3.71,5.12-14.15,5.12-25.73,0-4.81-.41-7.14-3.77-9.66a30.27,30.27,0,0,0-17.42-5.38c-6.54,0-20.31,4.32-17.5,15.93-.13,3.11-3,11.87-4.06,15.73"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M196.38,481.12c38.06,19.66,142.15,23,183.89-39,7.23-10.73,10.36-26.22,6.63-43.56"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M383.48,397.75c1.67,8.55,6,41.87-20.81,64"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M214.52,487.92c38.87,8.41,94.59,7.06,134.56-24.84,17-13.6,28.84-34.1,22.74-64.5"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M368.13,400.07c2.05,9.66,6.83,41.38-19,63"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M104.61,386.6c-5.15,15.31,9,36.27,29.62,37.6,14.57.94,27.74-7.14,32.24-18.8"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M168.8,398c-2.21,7.11-15.94,26.24-40.69,18.86-18-5.36-26.45-24.81-20.28-38.47"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKnot);
export default __webpack_public_path__ + "static/media/knot.cd9cc2c31fb7fba4751e235d6bf630e9.svg";
export { ForwardRef as ReactComponent };